import { VISIT_RESOURCE_REQUESTING } from "../coaching/constants";
import {
  GET_CAMPAIGN_RESOURCES_REQUESTING,
  GET_CAMPAIGN_RESOURCES_SUCCESS,
  GET_CAMPAIGN_RESOURCES_ERROR,
  SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING,
  SEND_CAMPAIGN_RESOURCE_FEEDBACK_SUCCESS,
  SEND_CAMPAIGN_RESOURCE_FEEDBACK_ERROR,
  VISIT_CAMPAIGN_RESOURCE_REQUESTING,
} from "./constants";
import { LOGOUT } from "../login/constants";
import { IResourceReducer } from "./types";

const initialState: IResourceReducer = {
  requesting: false,
  error: "",
  campaignResources: [],
};

const reducer = function resourceReducer(
  state: IResourceReducer = initialState,
  action,
): IResourceReducer {
  switch (action.type) {
    case GET_CAMPAIGN_RESOURCES_REQUESTING:
    case SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case GET_CAMPAIGN_RESOURCES_SUCCESS:
      return {
        ...state,
        campaignResources: action.payload,
        requesting: false,
      };

    case SEND_CAMPAIGN_RESOURCE_FEEDBACK_ERROR:
    case GET_CAMPAIGN_RESOURCES_ERROR:
      return {
        ...state,
        error: action.payload,
        requesting: false,
      };

    case SEND_CAMPAIGN_RESOURCE_FEEDBACK_SUCCESS:
      return {
        ...state,
        requesting: false,
      };

    case VISIT_RESOURCE_REQUESTING:
    case VISIT_CAMPAIGN_RESOURCE_REQUESTING:
      const campaignResources = state.campaignResources.map(resource => {
        if (resource.resourceId === action.payload.resourceId) {
          return {
            ...resource,
            isVisited: true,
          };
        }
        return resource;
      });

      return {
        ...state,
        campaignResources,
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
